export const getResponsiveStyles = (theme, language, screenSize, viewMode, emailLoading, emailStatus) => {

  const { isMobile, isTablet } = screenSize;
  const isRTL = language === "ar";

  // Use a unified font family (same as Dashboard)
  const fontFamily = 'inherit, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';

  return {
    container: {
      fontFamily,
      // padding: "clamp(12px, 3vw, 24px)",
      // maxWidth: "100%",
      // width: "100%",
      // margin: "0 auto",
      // minHeight: "100vh",
      // background: theme === "dark"
      //   ? "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)"
      //   : "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
      // boxSizing: "border-box",
      // overflowX: "hidden",
      marginLeft: -10,
      marginTop: 10,
      direction: isRTL ? "rtl" : "ltr",
    },

    headerSection: {
      fontFamily,
      background:
        theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
      padding: "1.55rem",
      // marginTop: -30,
      // marginLeft: isRTL ? 0 : 20,
      // marginRight: isRTL ? 20 : 0,
      borderRadius: "1rem",
      transition: "all 0.3s ease",
      boxShadow:
        theme === "dark"
          ? "0 0.5rem 2rem rgba(0,0,0,0.3), inset 0 0.0625rem 0 rgba(255,255,255,0.1)"
          : "0 0.5rem 2rem rgba(0,0,0,0.1)",
      backdropFilter: theme === "dark" ? "blur(0.625rem)" : "blur(0px)",
      WebkitBackdropFilter: theme === "dark" ? "blur(0.625rem)" : "blur(0px)",
      border:
        theme === "dark"
          ? "1px solid rgba(255,255,255,0.15)"
          : "1px solid rgba(0,0,0,0.05)",
      marginBottom: 20,
      marginTop: -40,
      marginLeft: 0,
      cursor: "pointer",
    },

    headerContent: {
      fontFamily,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: "clamp(16px, 3vw, 24px)",
      flexWrap: "wrap",
      gap: "16px"
    },

    headerLeft: {
      fontFamily,
      display: "flex",
      alignItems: "center",
      gap: "clamp(16px, 3vw, 24px)",
      flex: 1,
      minWidth: 0,
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    headerIcon: {
      width: "clamp(60px, 8vw, 80px)",
      height: "clamp(60px, 8vw, 80px)",
      borderRadius: "clamp(12px, 2vw, 20px)",
      background: "linear-gradient(135deg, #2e7cba, #8b5cf6)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 10px 30px rgba(59, 130, 246, 0.4)",
      flexShrink: 0
    },

    headerText: {
      fontFamily,
      flex: 1,
      minWidth: 0,
      textAlign: isRTL ? "right" : "left",
    },

    headerTitle: {
      fontFamily,
      color: theme === "dark" ? "white" : "#1a1a1a",
      fontWeight: "700",
      fontSize: isMobile ? "20px" : isTablet ? "24px" : "28px",
      textShadow: theme === "dark" ? "0 0.125rem 0.25rem rgba(0,0,0,0.3)" : "0 0.125rem 0.25rem rgba(0,0,0,0.1)",
      marginBottom: -15,
    },

    headerSubtitle: {
      fontFamily,
      fontSize: "clamp(14px, 2.5vw, 18px)",
      color: theme === "dark" ? "rgba(255,255,255,0.8)" : "rgba(26,26,26,0.7)",
      margin: 0,
      lineHeight: "1.5",
    },

    headerActions: {
      display: "flex",
      gap: "clamp(8px, 1.5vw, 12px)",
      alignItems: "center",
      flexWrap: "wrap"
    },

    statsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(min(200px, 100%), 1fr))",
      gap: "clamp(12px, 2.5vw, 20px)",
      marginBottom: "clamp(20px, 4vw, 32px)",
    },

    statCard: {
      background: theme === "dark"
        ? "rgba(255,255,255,0.05)"
        : "rgba(255,255,255,0.9)",
      padding: "clamp(20px, 4vw, 28px) clamp(16px, 3vw, 24px)",
      borderRadius: "clamp(12px, 2vw, 20px)",
      border: theme === "dark"
        ? "1px solid rgba(255,255,255,0.1)"
        : "1px solid rgba(0,0,0,0.05)",
      backdropFilter: "blur(20px)",
      boxShadow: theme === "dark"
        ? "0 10px 30px rgba(0,0,0,0.3)"
        : "0 10px 30px rgba(0,0,0,0.1)",
      position: "relative",
      overflow: "hidden",
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      width: "100%",
      boxSizing: "border-box"
    },

    statGradient: (color) => ({
      position: "absolute",
      top: 0,
      left: isRTL ? "auto" : 0,
      right: isRTL ? 0 : "auto",
      width: "100%",
      height: "4px",
      background: `linear-gradient(90deg, ${color}, ${color}99)`,
    }),

    statHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: "clamp(12px, 2vw, 16px)",
      flexWrap: "wrap",
      gap: "8px",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    statValue: {
      fontSize: "clamp(24px, 4vw, 32px)",
      fontWeight: "800",
      color: theme === "dark" ? "#fff" : "#1a1a1a",
      lineHeight: "1",
      margin: "0 0 8px 0",
      textAlign: isRTL ? "right" : "left",
    },

    statLabel: {
      fontSize: "clamp(12px, 1.5vw, 14px)",
      fontWeight: "500",
      color: theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      textAlign: isRTL ? "right" : "left",
    },

    statChange: (isPositive) => ({
      display: "flex",
      alignItems: "center",
      gap: "clamp(2px, 0.5vw, 4px)",
      fontSize: "clamp(10px, 1.5vw, 12px)",
      fontWeight: "600",
      color: isPositive ? "#10b981" : "#ef4444",
      background: isPositive
        ? "rgba(16, 185, 129, 0.1)"
        : "rgba(239, 68, 68, 0.1)",
      padding: "clamp(2px, 0.5vw, 4px) clamp(6px, 1vw, 8px)",
      borderRadius: "6px",
      flexDirection: isRTL ? "row-reverse" : "row",
    }),

    controlPanel: {
      background: theme === "dark"
        ? "rgba(255,255,255,0.03)"
        : "rgba(255,255,255,0.95)",
      padding: "clamp(16px, 3vw, 2px)",
      borderRadius: "clamp(12px, 2vw, 20px)",
      border: "1px solid rgba(148,163,184,0.15)",
      boxShadow: "0 1px 4px rgba(0,0,0,0.06), 0 0 0 1px rgba(148,163,184,0.15)",
      marginBottom: "40px",
      backdropFilter: "blur(20px)",

      // border: theme === "dark"
      //   ? "1px solid rgba(255,255,255,0.1)"
      //   : "1px solid rgba(0,0,0,0.05)",
      width: "100%",
      boxSizing: "border-box",
      marginLeft: isRTL ? 0 : 0,
      marginRight: isRTL ? 0 : 0,
    },

    controlRow: {
      display: "flex",
      gap: "clamp(8px, 2vw, 16px)",
      alignItems: "center",
      flexWrap: "wrap",
      marginBottom: "clamp(12px, 2.5vw, 20px)",
      flexDirection: isRTL ? "row" : "row",
    },

    searchContainer: {
      position: "relative",
      flex: 1,
      minWidth: "min(250px, 100%)",
      maxWidth: "400px"
    },

    searchIcon: {
      position: "absolute",
      left: isRTL ? "auto" : "clamp(12px, 2vw, 16px)",
      right: isRTL ? "clamp(12px, 2vw, 16px)" : "auto",
      top: "50%",
      transform: "translateY(-50%)",
      color: theme === "dark" ? "rgba(255,255,255,0.4)" : "rgba(26,26,26,0.4)",
    },

    searchInput: {
      width: "100%",
      padding: isRTL
        ? "clamp(10px, 2vw, 14px) clamp(40px, 6vw, 48px) clamp(10px, 2vw, 14px) clamp(12px, 2vw, 16px)"
        : "clamp(10px, 2vw, 14px) clamp(12px, 2vw, 16px) clamp(10px, 2vw, 14px) clamp(40px, 6vw, 48px)",
      borderRadius: "clamp(8px, 1.5vw, 12px)",
      border: theme === "dark"
        ? "1px solid rgba(255,255,255,0.1)"
        : "1px solid rgba(0,0,0,0.1)",
      background: theme === "dark"
        ? "rgba(255,255,255,0.05)"
        : "rgba(255,255,255,0.9)",
      color: theme === "dark" ? "#fff" : "#1a1a1a",
      fontSize: "clamp(12px, 1.5vw, 14px)",
      outline: "none",
      transition: "all 0.2s ease",
      boxSizing: "border-box",
      textAlign: isRTL ? "right" : "left",
    },

    filterSelect: {
      appearance: "none",
      WebkitAppearance: "none",
      MozAppearance: "none",
      background: theme === "dark"
        ? "rgba(30, 41, 59, 0.9)"
        : "rgba(255, 255, 255, 0.95)",
      color: theme === "dark" ? "#f1f5f9" : "#1e293b",
      border: theme === "dark"
        ? "1px solid rgba(255, 255, 255, 0.2)"
        : "1px solid rgba(0, 0, 0, 0.15)",
      borderRadius: "0.625rem",
      padding: "0.875rem 2.5rem 0.875rem 1rem",
      fontWeight: "500",
      width: "15%",
      boxSizing: "border-box",
      outline: "none",
      cursor: "pointer",
      textAlign: isRTL ? "right" : "left",
      direction: isRTL ? "rtl" : "ltr",
    },

    actionButton: (variant = 'default') => {
      const variants = {
        default: {
          background: theme === "dark"
            ? "rgba(255,255,255,0.1)"
            : "rgba(0,0,0,0.05)",
          color: theme === "dark" ? "#fff" : "#1a1a1a",
          border: theme === "dark"
            ? "1px solid rgba(255,255,255,0.2)"
            : "1px solid rgba(0,0,0,0.1)",
        },
        primary: {
          background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
          color: "#fff",
          border: "none",
          boxShadow: "0 4px 12px rgba(59, 130, 246, 0.4)",
        },
        success: {
          background: "linear-gradient(135deg, #10b981, #059669)",
          color: "#fff",
          border: "none",
          boxShadow: "0 4px 12px rgba(16, 185, 129, 0.4)",
        }
      };

      return {
        ...variants[variant],
        padding: "clamp(8px, 1.5vw, 12px) clamp(14px, 2.5vw, 20px)",
        borderRadius: "clamp(6px, 1vw, 10px)",
        fontSize: "clamp(12px, 1.5vw, 14px)",
        fontWeight: "600",
        cursor: "pointer",
        transition: "all 0.2s ease",
        display: "flex",
        alignItems: "center",
        gap: "clamp(4px, 1vw, 8px)",
        outline: "none",
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        flexDirection: isRTL ? "row-reverse" : "row",
      };
    },

    categoriesGrid: {
      display: "flex",
      flexWrap: "nowrap",
      gap: "clamp(12px, 2vw, 16px)",
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
      scrollbarWidth: "none",  // ← أضف هذا السطر
      msOverflowStyle: "none", // ← أضف هذا السطر
      marginBottom: "40px",
      marginTop: 10,
    },

    categoryCard: (isSelected, color) => ({
      marginTop:10,
      marginRight:5,
      padding: "clamp(16px, 3vw, 20px)",
      borderRadius: "clamp(12px, 2vw, 16px)",
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      border: isSelected
        ? `1.5px solid ${color}`
        : "1px solid rgba(27, 27, 28, 0.33)",
      boxShadow: isSelected
        ? `0 0 0 3px ${color}1F`
        : "0 1px 3px rgba(0,0,0,0.07), 0 0 0 1px rgba(148, 163, 184, 0.33)",
      // border: isSelected
      //   ? `2px solid ${color}`
      //   : theme === "dark"
      //     ? "1px solid rgba(255,255,255,0.1)"
      //     : "1px solid rgba(0,0,0,0.05)",
      background: isSelected
        ? `${color}15`
        : theme === "dark"
          ? "rgba(255,255,255,0.02)"
          : "rgba(255,255,255,0.5)",
      position: "relative",
      overflow: "hidden",
      minWidth: 0,
      boxSizing: "border-box",
      minHeight: "140px",  // ← أضف هذا السطر
      display: "flex",      // ← أضف هذا السطر
      flexDirection: "column", // ← أضف هذا السطر
      justifyContent: "space-between" // ← أضف هذا السطر
    }),

    categoryIcon: (color) => ({
      width: "clamp(40px, 6vw, 48px)",
      height: "clamp(40px, 6vw, 48px)",
      borderRadius: "clamp(8px, 1.5vw, 12px)",
      background: `${color}20`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto clamp(8px, 1.5vw, 12px)",
      color: color,
    }),

    categoryName: {
      fontSize: "clamp(14px, 2vw, 16px)",
      fontWeight: "600",
      color: theme === "dark" ? "#fff" : "#1a1a1a",
      textAlign: "center",
      marginBottom: "4px",
      lineHeight: "1.2"
    },

    categoryCount: {
      fontSize: "clamp(10px, 1.5vw, 12px)",
      color: theme === "dark" ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.5)",
      textAlign: "center",
      marginBottom: "clamp(4px, 1vw, 8px)",
    },

    categoryDescription: {
      fontSize: "clamp(9px, 1.2vw, 11px)",
      color: theme === "dark" ? "rgba(255,255,255,0.5)" : "rgba(26,26,26,0.4)",
      textAlign: "center",
      lineHeight: "1.3",
    },

    reportsGrid: {
      display: "grid",
      gridTemplateColumns: viewMode === 'grid'
        ? "repeat(auto-fit, minmax(min(350px, 100%), 1fr))"
        : "1fr",
      gap: "clamp(16px, 3vw, 24px)",
      marginBottom: "clamp(20px, 4vw, 32px)",
    },

    reportCard: {
      fontFamily,
      background: theme === "dark"
        ? "rgba(255,255,255,0.03)"
        : "rgba(255,255,255,0.95)",
      padding: "clamp(20px, 4vw, 28px)",
      borderRadius: "clamp(12px, 2vw, 20px)",
      border: theme === "dark"
        ? "1px solid rgba(255,255,255,0.1)"
        : "1px solid rgba(0,0,0,0.05)",
      backdropFilter: "blur(20px)",
      boxShadow: theme === "dark"
        ? "0 10px 30px rgba(0,0,0,0.3)"
        : "0 10px 30px rgba(0,0,0,0.1)",
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      position: "relative",
      overflow: "hidden",
      width: "100%",
      boxSizing: "border-box"
    },

    reportHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: "clamp(16px, 3vw, 20px)",
      flexWrap: "wrap",
      gap: "12px",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    reportTitleSection: {
      flex: 1,
      minWidth: 0,
      textAlign: "Center",
    },

    reportTitle: {
      fontFamily,
      fontSize: "clamp(16px, 3vw, 20px)",
      fontWeight: "700",
      color: theme === "dark" ? "#fff" : "#1a1a1a",
      marginBottom: "clamp(6px, 1vw, 8px)",
      lineHeight: "1.2",
    },

    reportDescription: {
      fontFamily,
      fontSize: "clamp(12px, 1.8vw, 14px)",
      color: theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
      lineHeight: "1.5",
      marginBottom: "clamp(12px, 2vw, 16px)",
      width: "100%",
      display: '-webkit-box',
      WebkitLineClamp: 3,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    tagsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 'clamp(4px, 1vw, 8px)',
      marginTop: '8px',
      width: '100%',
      minHeight: '0',
    },

    reportTags: {
      display: "flex",
      gap: "clamp(4px, 1vw, 8px)",
      flexWrap: "wrap",
      marginBottom: "clamp(12px, 2vw, 16px)",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    reportTag: {
      fontFamily,
      padding: "clamp(2px, 0.5vw, 4px) clamp(6px, 1.5vw, 10px)",
      borderRadius: "20px",
      fontSize: "clamp(9px, 1.2vw, 11px)",
      fontWeight: "500",
      background: theme === "dark"
        ? "rgba(59, 130, 246, 0.2)"
        : "rgba(59, 130, 246, 0.1)",
      color: "#2e7cba",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      whiteSpace: "nowrap"
    },

    reportMeta: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
      gap: "clamp(12px, 2vw, 16px)",
      marginBottom: "clamp(16px, 3vw, 20px)",
      padding: "clamp(12px, 2vw, 16px)",
      borderRadius: "clamp(8px, 1.5vw, 12px)",
      background: theme === "dark"
        ? "rgba(255,255,255,0.02)"
        : "rgba(0,0,0,0.02)",
    },

    metaItem: {
      fontFamily,
      display: "flex",
      alignItems: "center",
      gap: "clamp(4px, 1vw, 8px)",
      fontSize: "clamp(10px, 1.5vw, 12px)",
      color: theme === "dark" ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.5)",
      minWidth: 0,
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    reportStats: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "clamp(16px, 3vw, 20px)",
      flexWrap: "wrap",
      gap: "12px",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    statGroup: {
      display: "flex",
      alignItems: "center",
      gap: "clamp(8px, 2vw, 16px)",
      flexWrap: "wrap",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    statItem: {
      display: "flex",
      alignItems: "center",
      gap: "clamp(2px, 0.5vw, 4px)",
      fontSize: "clamp(10px, 1.5vw, 12px)",
      color: theme === "dark" ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.5)",
      whiteSpace: "nowrap",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    ratingStars: {
      display: "flex",
      gap: "2px",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    statusBadge: (status) => {
      const statusConfig = {
        ready: { color: "#10b981", bg: "rgba(16, 185, 129, 0.1)" },
        generating: { color: "#f59e0b", bg: "rgba(245, 158, 11, 0.1)" },
        error: { color: "#ef4444", bg: "rgba(239, 68, 68, 0.1)" },
      };

      const config = statusConfig[status] || statusConfig.ready;

      return {
        display: "flex",
        alignItems: "center",
        gap: "clamp(4px, 1vw, 6px)",
        padding: "clamp(6px, 1vw, 8px) clamp(8px, 1.5vw, 12px)",
        borderRadius: "20px",
        fontSize: "clamp(10px, 1.5vw, 12px)",
        fontWeight: "600",
        color: config.color,
        background: config.bg,
        textTransform: "capitalize",
        whiteSpace: "nowrap",
        flexDirection: isRTL ? "row-reverse" : "row",
      };
    },

    actionButtons: {
      display: "flex",
      gap: "clamp(6px, 1vw, 8px)",
      flexWrap: "nowrap",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
      background: 'transparent',
      boxShadow: 'none',
      border: 'none',
    },

    actionBtn: (variant) => {
      const variants = {
        view: { bg: "#2e7cba", color: "#fff" },
        download: { bg: "#10b981", color: "#fff" },
        share: {
          bg: theme === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)",
          color: theme === "dark" ? "#fff" : "#1a1a1a"
        },
      };

      const style = variants[variant] || variants.share;

      return {
        fontFamily,
        padding: "clamp(8px, 1.5vw, 10px) clamp(12px, 2vw, 16px)",
        minWidth: "fit-content",
        borderRadius: "clamp(6px, 1vw, 10px)",
        border: "none",
        fontSize: "clamp(11px, 1.5vw, 13px)",
        fontWeight: "600",
        cursor: "pointer",
        transition: "all 0.18s ease",
        display: "inline-flex",
        alignItems: "center",
        gap: "clamp(6px, 1vw, 8px)",
        background: style.bg,
        color: style.color,
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        flexDirection: isRTL ? "row-reverse" : "row",
        boxShadow: 'none',
        paddingTop: "clamp(8px, 1.2vw, 10px)",
        paddingBottom: "clamp(8px, 1.2vw, 10px)",
      };
    },

    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0,0,0,0.8)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      backdropFilter: "blur(8px)",
      padding: "clamp(12px, 2vw, 20px)",
    },

    modalContainer: {
      background: theme === "dark"
        ? "rgba(15, 23, 42, 0.95)"
        : "rgba(255, 255, 255, 0.95)",
      backdropFilter: "blur(30px)",
      border: theme === "dark"
        ? "1px solid rgba(255,255,255,0.1)"
        : "1px solid rgba(0,0,0,0.1)",
      borderRadius: "clamp(16px, 3vw, 24px)",
      padding: "0",
      width: "min(90vw, 600px)",
      maxHeight: "90vh",
      overflowY: "auto",
      boxShadow: "0 25px 50px -12px rgba(0,0,0,0.5)",
      boxSizing: "border-box",
      direction: isRTL ? "rtl" : "ltr",
      // أضف دول
      scrollbarWidth: "none", // Firefox
      msOverflowStyle: "none", // IE/Edge
    },

    modalHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "clamp(20px, 4vw, 32px) clamp(20px, 4vw, 32px) 0 clamp(20px, 4vw, 32px)",
      marginBottom: "clamp(16px, 3vw, 24px)",
      flexWrap: "wrap",
      gap: "12px",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    modalTitleSection: {
      display: "flex",
      alignItems: "center",
      gap: "clamp(12px, 2vw, 16px)",
      flex: 1,
      minWidth: 0,
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    modalIcon: {
      width: "clamp(40px, 6vw, 48px)",
      height: "clamp(40px, 6vw, 48px)",
      borderRadius: "clamp(8px, 1.5vw, 12px)",
      background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      flexShrink: 0
    },

    modalTitle: {
      fontSize: "clamp(18px, 3vw, 24px)",
      fontWeight: "700",
      color: theme === "dark" ? "#fff" : "#1a1a1a",
      margin: 0,
      lineHeight: "1.2",
      textAlign: isRTL ? "right" : "left",
    },

    modalSubtitle: {
      fontSize: "clamp(12px, 1.8vw, 14px)",
      color: theme === "dark" ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.6)",
      margin: "4px 0 0 0",
      textAlign: isRTL ? "right" : "left",
    },

    closeButton: {
      background: "none",
      border: "none",
      color: theme === "dark" ? "rgba(255,255,255,0.6)" : "rgba(26,26,26,0.6)",
      cursor: "pointer",
      padding: "clamp(6px, 1vw, 8px)",
      borderRadius: "8px",
      transition: "all 0.2s ease",
      flexShrink: 0
    },

    reportPreview: {
      margin: "0 clamp(20px, 4vw, 32px) clamp(16px, 3vw, 24px)",
      padding: "clamp(16px, 3vw, 20px)",
      borderRadius: "clamp(12px, 2vw, 16px)",
      background: theme === "dark"
        ? "rgba(255,255,255,0.03)"
        : "rgba(0,0,0,0.02)",
      border: theme === "dark"
        ? "1px solid rgba(255,255,255,0.1)"
        : "1px solid rgba(0,0,0,0.05)",
    },

    previewHeader: {
      display: "flex",
      gap: "clamp(12px, 2vw, 16px)",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    previewThumbnail: {
      width: "clamp(50px, 8vw, 60px)",
      height: "clamp(50px, 8vw, 60px)",
      borderRadius: "clamp(8px, 1.5vw, 12px)",
      background: "linear-gradient(135deg, #10b981, #059669)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
      flexShrink: 0,
    },

    previewInfo: {
      flex: 1,
      minWidth: 0,
      textAlign: isRTL ? "right" : "left",
    },

    previewTitle: {
      fontSize: "clamp(16px, 2.5vw, 18px)",
      fontWeight: "600",
      color: theme === "dark" ? "#fff" : "#1a1a1a",
      margin: "0 0 8px 0",
      lineHeight: "1.2",
    },

    previewDescription: {
      fontSize: "clamp(12px, 1.8vw, 14px)",
      color: theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.6)",
      lineHeight: "1.4",
      margin: "0 0 12px 0",
    },

    previewMeta: {
      display: "flex",
      gap: "clamp(4px, 1vw, 8px)",
      fontSize: "clamp(10px, 1.5vw, 12px)",
      color: theme === "dark" ? "rgba(255,255,255,0.5)" : "rgba(26,26,26,0.5)",
      flexWrap: "wrap",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    emailForm: {
      padding: "0 clamp(20px, 4vw, 32px) clamp(16px, 3vw, 24px)",
    },

    formGroup: {
      marginBottom: "clamp(16px, 3vw, 20px)",
    },

    formLabel: {
      display: "block",
      fontSize: "clamp(12px, 1.8vw, 14px)",
      fontWeight: "600",
      color: theme === "dark" ? "#fff" : "#1a1a1a",
      marginBottom: "clamp(6px, 1vw, 8px)",
      textAlign: isRTL ? "right" : "left",
    },

    recipientTags: {
      display: "flex",
      flexWrap: "wrap",
      gap: "clamp(6px, 1vw, 8px)",
      padding: "clamp(8px, 1.5vw, 12px)",
      borderRadius: "clamp(8px, 1.5vw, 12px)",
      border: theme === "dark"
        ? "1px solid rgba(255,255,255,0.1)"
        : "1px solid rgba(0,0,0,0.1)",
      background: theme === "dark"
        ? "rgba(255,255,255,0.03)"
        : "rgba(255,255,255,0.9)",
      minHeight: "clamp(40px, 6vw, 48px)",
      alignItems: "center",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    recipientTag: {
      display: "flex",
      alignItems: "center",
      gap: "clamp(4px, 1vw, 6px)",
      padding: "clamp(4px, 1vw, 6px) clamp(8px, 1.5vw, 10px)",
      borderRadius: "20px",
      background: "#2e7cba",
      color: "#fff",
      fontSize: "clamp(10px, 1.5vw, 12px)",
      fontWeight: "500",
      whiteSpace: "nowrap",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    removeRecipient: {
      background: "none",
      border: "none",
      color: "#fff",
      cursor: "pointer",
      padding: "2px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    recipientInput: {
      border: "none",
      outline: "none",
      background: "transparent",
      color: theme === "dark" ? "#fff" : "#1a1a1a",
      fontSize: "clamp(12px, 1.8vw, 14px)",
      flex: 1,
      minWidth: "clamp(120px, 20vw, 150px)",
      textAlign: isRTL ? "right" : "left",
    },

    formInput: {
      width: "100%",
      padding: "clamp(8px, 1.5vw, 12px) clamp(12px, 2vw, 16px)",
      borderRadius: "clamp(8px, 1.5vw, 12px)",
      border: theme === "dark"
        ? "1px solid rgba(255,255,255,0.1)"
        : "1px solid rgba(0,0,0,0.1)",
      background: theme === "dark"
        ? "rgba(255,255,255,0.03)"
        : "rgba(255,255,255,0.9)",
      color: theme === "dark" ? "#fff" : "#1a1a1a",
      fontSize: "clamp(12px, 1.8vw, 14px)",
      outline: "none",
      boxSizing: "border-box",
      textAlign: isRTL ? "right" : "left",
    },

    formTextarea: {
      width: "100%",
      padding: "clamp(8px, 1.5vw, 12px) clamp(12px, 2vw, 16px)",
      borderRadius: "clamp(8px, 1.5vw, 12px)",
      border: theme === "dark"
        ? "1px solid rgba(255,255,255,0.1)"
        : "1px solid rgba(0,0,0,0.1)",
      background: theme === "dark"
        ? "rgba(255,255,255,0.03)"
        : "rgba(255,255,255,0.9)",
      color: theme === "dark" ? "#fff" : "#1a1a1a",
      fontSize: "clamp(12px, 1.8vw, 14px)",
      outline: "none",
      resize: "vertical",
      minHeight: "clamp(80px, 12vw, 100px)",
      fontFamily: "inherit",
      boxSizing: "border-box",
      textAlign: isRTL ? "right" : "left",
    },

    checkboxLabel: {
      display: "flex",
      alignItems: "center",
      gap: "clamp(8px, 1.5vw, 10px)",
      cursor: "pointer",
      fontSize: "clamp(12px, 1.8vw, 14px)",
      color: theme === "dark" ? "rgba(255,255,255,0.8)" : "rgba(26,26,26,0.7)",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    checkbox: {
      width: "clamp(14px, 2vw, 16px)",
      height: "clamp(14px, 2vw, 16px)",
      accentColor: "#2e7cba",
    },

    modalActions: {
      display: "flex",
      gap: "clamp(8px, 1.5vw, 12px)",
      justifyContent: "flex-end",
      padding: "clamp(16px, 3vw, 24px) clamp(20px, 4vw, 32px) clamp(20px, 4vw, 32px)",
      borderTop: theme === "dark"
        ? "1px solid rgba(255,255,255,0.1)"
        : "1px solid rgba(0,0,0,0.05)",
      flexWrap: "wrap",
      width: "100%",
      boxSizing: "border-box",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    cancelButton: {
      padding: "clamp(8px, 1.5vw, 12px) clamp(16px, 3vw, 24px)",
      borderRadius: "clamp(8px, 1.5vw, 12px)",
      border: theme === "dark"
        ? "1px solid rgba(255,255,255,0.2)"
        : "1px solid rgba(0,0,0,0.1)",
      background: "transparent",
      color: theme === "dark" ? "rgba(255,255,255,0.8)" : "rgba(26,26,26,0.7)",
      fontSize: "clamp(12px, 1.8vw, 14px)",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.2s ease",
      whiteSpace: "nowrap"
    },

    notifyButton: {
      padding: "clamp(8px, 1.5vw, 12px) clamp(16px, 3vw, 24px)",
      borderRadius: "clamp(8px, 1.5vw, 12px)",
      border: "none",
      background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
      color: "#fff",
      fontSize: "clamp(12px, 1.8vw, 14px)",
      fontWeight: "600",
      cursor: emailLoading ? "not-allowed" : "pointer",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      gap: "clamp(4px, 1vw, 8px)",
      opacity: emailLoading ? 0.7 : 1,
      whiteSpace: "nowrap",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    attachButton: {
      padding: "clamp(8px, 1.5vw, 12px) clamp(16px, 3vw, 24px)",
      borderRadius: "clamp(8px, 1.5vw, 12px)",
      border: "none",
      background: "linear-gradient(135deg, #10b981, #059669)",
      color: "#fff",
      fontSize: "clamp(12px, 1.8vw, 14px)",
      fontWeight: "600",
      cursor: emailLoading ? "not-allowed" : "pointer",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      gap: "clamp(4px, 1vw, 8px)",
      opacity: emailLoading ? 0.7 : 1,
      whiteSpace: "nowrap",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    statusAlert: (type) => ({
      position: "fixed",
      top: "clamp(16px, 3vw, 24px)",
      right: isRTL ? "auto" : "clamp(16px, 3vw, 24px)",
      left: isRTL ? "clamp(16px, 3vw, 24px)" : "auto",
      zIndex: 2000,
      borderRadius: "clamp(8px, 1.5vw, 12px)",
      border: "1px solid",
      maxWidth: "min(90vw, 400px)",
      backdropFilter: "blur(20px)",
      backgroundColor: type === 'error'
        ? "rgba(239, 68, 68, 0.1)"
        : "rgba(34, 197, 94, 0.1)",
      borderColor: type === 'error' ? "#ef4444" : "#22c55e",
      boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
      animation: "slideIn 0.3s ease-out",
    }),

    alertContent: {
      display: "flex",
      alignItems: "center",
      gap: "clamp(8px, 1.5vw, 12px)",
      padding: "clamp(12px, 2vw, 16px) clamp(16px, 3vw, 20px)",
      color: emailStatus.type === 'error' ? "#ef4444" : "#22c55e",
      fontSize: "clamp(12px, 1.8vw, 14px)",
      fontWeight: "500",
      flexDirection: isRTL ? "row-reverse" : "row",
    },

    alertClose: {
      background: "none",
      border: "none",
      color: "inherit",
      cursor: "pointer",
      padding: "4px",
      borderRadius: "4px",
      marginLeft: isRTL ? "0" : "auto",
      marginRight: isRTL ? "auto" : "0",
      opacity: 0.7,
      transition: "opacity 0.2s ease",
    },
  };
};